import * as React from 'react';
import { Button } from '@nackle/paper';
import { Cross } from '@nackle/icons/dist/react-es/lindua';
// shared
import ClickableOverlay from '../clickable-overlay';
// styles
import './modal.less';

export default class Modal extends React.Component {
    state = {
        open: !!this.props.open
    };
    open = () => {
        const open = !this.state.open;
        const onClose = this.props.onClose;
        const onOpen = this.props.onOpen;
        this.setState( { open } );
        if ( !!onClose && !open ) {
            onClose();
        } else {
            onOpen();
        }
    };
    render() {
        const { modalContainerId, modalOpener, genericId, Nav } = this.props;
        return [
            <Button
                type="text"
                onClick={ this.open }
                data-open-modal-button-id={ genericId }
                className="modal-opener-wrapper-button"
                key={ `open-modal-btn-${ genericId }` }
                id={ `open-modal-btn-${ genericId }` }
            >
                { modalOpener }
            </Button>,
            this.state.open && (
                <ClickableOverlay
                    id={ modalContainerId }
                    key={ `modal-content-${ genericId }` }
                    onClick={ this.open }
                >
                    <div className="modal" id={ `modal-${ genericId }` }>
                        { !!Nav && Nav }
                        <div className="modal-content-wrapper">{ this.props.children }</div>
                        <Button
                            type="text"
                            size="large"
                            icon={ <Cross /> }
                            className="close-modal-btn"
                            id={ `close-modal-btn-${ genericId }` }
                            onClick={ this.open }
                        />
                    </div>
                </ClickableOverlay>
            )
        ];
    }
}
